module.exports = __webpack_public_path__ + "img/other-icon.40edf1b9.png";